import { render, staticRenderFns } from "./MyPagination.vue?vue&type=template&id=3c2015b4"
import script from "./MyPagination.vue?vue&type=script&lang=js"
export * from "./MyPagination.vue?vue&type=script&lang=js"
import style0 from "./MyPagination.vue?vue&type=style&index=0&id=3c2015b4&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports